'use strict';

// Меню разделов: <li du-scrollspy="section5"><a href="/#section5" du-smooth-scroll>. Повторяет
// angular-scroll 0.7.3 со смещением 60 px: пункт раздела у верхнего края окна получает класс active,
// меню плавно прокручивается к нему, ссылка плавно прокручивает страницу к разделу.
// Отступ раздела от верха окна: прежнее значение duScrollOffset приложения.
var SECTION_OFFSET = 60;

angular.module('superdostavka.commonDirectives')
.directive('duScrollspy', ['$timeout', function ($timeout) {
    var spies = [];
    var active = null;
    var timer = false;
    var queued = false;

    // Активен раздел, верх которого выше линии смещения (с запасом 20 px), а низ ещё виден.
    // Из нескольких таких разделов выбирается ближайший к верху окна.
    function update() {
        var next = null;
        var nextTop;
        queued = false;
        spies.forEach(function (spy) {
            spy.target = spy.target || document.getElementById(spy.id);
            if (!spy.target) {
                return;
            }
            var rect = spy.target.getBoundingClientRect();
            if (rect.top - SECTION_OFFSET < 20 && -rect.top < rect.height && (!next || nextTop < rect.top)) {
                next = spy;
                nextTop = rect.top;
            }
        });
        if (next === active) {
            return;
        }
        if (active) {
            active.element.classList.remove('active');
        }
        if (next) {
            next.element.classList.add('active');
            // Меню прокручивается к активному пункту.
            var menu = document.querySelector('.navigation__menu');
            var item = document.querySelector('.navigation__menu .active');
            if (menu && item) {
                menu.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
            }
        }
        active = next;
    }

    // Первая прокрутка обрабатывается сразу, следующие — не чаще раза в 100 мс.
    function onScroll() {
        if (timer) {
            queued = true;
            return;
        }
        update();
        timer = $timeout(function () {
            timer = false;
            if (queued) {
                update();
            }
        }, 100, false);
    }

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Пункт подключается после запуска страницы и сразу проверяет положение разделов.
            $timeout(function () {
                if (!spies.length) {
                    document.addEventListener('scroll', onScroll);
                }
                spies.push({ id: attrs.duScrollspy, element: element[0] });
                onScroll();
            }, 0, false);
        }
    };
}])
.directive('duSmoothScroll', [function () {
    var DURATION = 350;
    var CANCEL_EVENTS = ['scroll', 'mousedown', 'mousewheel', 'touchmove', 'keydown'];
    var animation = null;

    function easing(x) {
        return x < 0.5 ? Math.pow(x * 2, 2) / 2 : 1 - Math.pow((1 - x) * 2, 2) / 2;
    }

    function scrollLeft() {
        return window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
    }

    function scrollTop() {
        return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    }

    function scrollToElement(target) {
        var top = scrollTop() + target.getBoundingClientRect().top - SECTION_OFFSET;
        var startLeft = scrollLeft();
        var startTop = scrollTop();
        var deltaLeft = Math.round(0 - startLeft);
        var deltaTop = Math.round(top - startTop);
        var startTime = null;
        var progress = 0;

        function bind(method) {
            CANCEL_EVENTS.forEach(function (name) {
                document[method](name, cancel);
            });
        }

        // Нажатие клавиши, кнопки мыши или колесо после первого кадра останавливает прокрутку.
        function cancel(event) {
            if (!event || (progress && event.which > 0)) {
                bind('removeEventListener');
                cancelAnimationFrame(animation);
                animation = null;
            }
        }

        function step(timestamp) {
            if (startTime === null) {
                startTime = timestamp;
            }
            progress = timestamp - startTime;
            var percent = progress >= DURATION ? 1 : easing(progress / DURATION);
            window.scrollTo(startLeft + Math.ceil(deltaLeft * percent), startTop + Math.ceil(deltaTop * percent));
            if (percent < 1) {
                animation = requestAnimationFrame(step);
            } else {
                bind('removeEventListener');
                animation = null;
            }
        }

        // Как в модуле: новая прокрутка останавливает кадры прежней.
        if (animation) {
            cancel();
        }
        if (!deltaLeft && !deltaTop) {
            return;
        }
        window.scrollTo(startLeft, startTop);
        bind('addEventListener');
        animation = requestAnimationFrame(step);
    }

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element[0].addEventListener('click', function (event) {
                var href = attrs.href;
                if (!href || href.indexOf('#') === -1) {
                    return;
                }
                // Раздела нет на странице: ссылка ведёт на главную обычным переходом.
                var target = document.getElementById(href.replace(/.*(?=#[^\s]+$)/, '').substring(1));
                if (!target) {
                    return;
                }
                event.stopPropagation();
                event.preventDefault();
                scrollToElement(target);
            });
        }
    };
}]);
